import { render, staticRenderFns } from "./SidebarNavLabel.vue?vue&type=template&id=51b84ffe"
import script from "./SidebarNavLabel.vue?vue&type=script&lang=js"
export * from "./SidebarNavLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports